import React from 'react';
import type { ReactNode } from 'react';

import { InfoIcon } from '../../../assets/icons/icons';
import styles from './Notice.module.scss';

interface NoticeProps {
    children: ReactNode;
}

/** Пояснение над таблицей: объясняет, что за список и что с ним делать. */
export function Notice({ children }: NoticeProps) {
    return (
        <div className={styles.notice}>
            <InfoIcon className={styles.icon} />
            <div>{children}</div>
        </div>
    );
}
